import { useState, useEffect } from 'react';
import { useToken } from 'hooks/useToken'
import { decodeStorage, encodeStorage, removeStorage } from 'functions/storageBase64';
import { getCardList } from 'services/Cards'


export function useArrayCard() {

    const session_token = decodeStorage('session_token')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const cardending = decodeStorage('cardending')
    
    const [responseCardList, setResponseCardList] = useState()
    const [associatedCards, setAssociatedCards] = useState()
    const [errorCode, setErrorCode] = useState()
    const [addCardNew, setAddCardNew] = useState(false)

    const firstSessionGCL = window.sessionStorage.getItem('firstSessionGCL')

    /*  --------------------------- Inicio --------------------------------------  */
    const timeToken = useToken({ firstActive: false, name: "array card", timeRef: 1000 })
    const [actionOK, setActionOk] = useState(false)
        useEffect(() => {
            setTimeout(function(){
                setActionOk('ready')
            },700)
        }, [])
    /*  --------------------------- Inicio Peticiones --------------------------------------  */
        //  Ajusta Los tiempos y refresca token
        const [serviceRT, setServiceRT] = useState(false)
        useEffect(()=>{
            if(actionOK){
                let  actTimeLS = Date.now()
                let  atExpLS = decodeStorage('access_token_exp') * 1000
    
                // console.log('------------------------------')
                // console.log('actTimeLS   : ', new Date() )
                // console.log('actTimeLS m : ', ( new Date( Date.now() + 180000) ) )
                // console.log('atExp   : ', new Date (atExpLS) )
                // console.log('time ok : ', actTimeLS <= atExpLS)
                // console.log('actionOK: ', actionOK)
                // console.log('------------------------------')
                
                if(actTimeLS <= atExpLS || Date.now() <= (decodeStorage('access_token_exp') * 1000) ){
                    setServiceRT(true)
                }
                else{
                    timeToken.forceToken(true)
                }
            }
        },[timeToken.newToken, actionOK])
    /*  --------------------------- Fin --------------------------------------  */

    useEffect(() => {
        if(serviceRT){
            if (session_token) {
                if ((!sears_numero_internet || sears_numero_internet === "undefined") || (!cardending || cardending === "undefined")) {
                    // liveToken()
                    // getCardList()
                    // .then(setResponseCardList)
                } else {
                    if(decodeStorage('associatedCards') ){
                        if(!firstSessionGCL){
                            getCardList()
                            .then(setResponseCardList)
                            window.sessionStorage.setItem('firstSessionGCL', true)
                        }else{
                            // console.log('si hay ')
                            setAssociatedCards( decodeStorage('associatedCards') )
                            setAddCardNew(false)
                        }
                        
                    }else{
                        // console.log('no hay')
                        getCardList()
                        .then(setResponseCardList)
                    }
                }
            }
        }
    }, [serviceRT, addCardNew])

    useEffect(() => {
        if (responseCardList) {
            if (responseCardList.statusCode === 200) {
                if (responseCardList.data) {
                    // console.log("response card list... ", responseCardList?.data)
                    encodeStorage('associatedCards', responseCardList?.data)
                    setAssociatedCards(responseCardList?.data)
                    setAddCardNew(false)
                }
            }
            else if (responseCardList.statusCode === 400) {
                // console.log('1')
                let codeError = JSON.parse(responseCardList?.data)
                setErrorCode(codeError)
                if (JSON.parse(responseCardList?.data).codMen === "ERR001") {
                    // console.log('2')
                    removeStorage('cardending')
                    removeStorage('sears_numero_internet')
                    if ((!sears_numero_internet || sears_numero_internet === "undefined") || (!cardending || cardending === "undefined")) {
                        // console.log('3')
                        removeStorage('lastConsultData')
                        removeStorage('associatedCards')
                        //window.location.reload()
                    }
                    else {
                        // console.log('4')
                        window.location.reload()
                    }
                }
            }
            else if (responseCardList.statusCode >= 500) {
                setErrorCode(responseCardList.statusCode)
            }
        }
    }, [responseCardList])

    const [validateCards, setValidateCards] = useState(false)
    useEffect(() => {
        if (associatedCards) {
            encodeStorage('cardending', associatedCards?.cta_nva.substr(-4));
            encodeStorage('sears_numero_internet', associatedCards?.noInternet);
            setValidateCards(true);
        }
    }, [associatedCards])



    const udCardsArray = (value) => {
        setAddCardNew(value)
    }

    return {
        validateCards,
        associatedCards,
        errorCode,
        udCardsArray,
        setValidateCards
    }
}